var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#ED2B30",
    fillOpacity: 0.05
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.375 11.593C27 9.29712 23.875 8.00024 20.5469 8.00024C10.9948 8.00024 4.99688 18.3492 9.76667 26.5815L8 33.0002L14.599 31.2794C17.474 32.8325 19.8292 32.695 20.5531 32.7867C31.6292 32.7867 37.1427 19.3867 29.3594 11.6336L29.375 11.593Z",
    fill: "#ECEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5698 30.6574L20.5635 30.6563H20.5469C17.2323 30.6563 15.1146 29.0866 14.9063 28.9959L11 30.0116L12.0469 26.2147L11.7979 25.8241C10.7667 24.1824 10.2188 22.2918 10.2188 20.3449C10.2188 11.1855 21.4115 6.60531 27.8885 13.0793C34.35 19.4855 29.8135 30.6574 20.5698 30.6574Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2366 22.9033L26.2272 22.9814C25.9137 22.8251 24.3866 22.0783 24.1022 21.9751C23.4637 21.7387 23.6439 21.9376 22.4179 23.3418C22.2356 23.5449 22.0543 23.5606 21.7449 23.4199C21.4324 23.2637 20.4293 22.9356 19.2418 21.8731C18.3168 21.0449 17.696 20.0293 17.5126 19.7168C17.2074 19.1897 17.846 19.1147 18.4272 18.0147C18.5314 17.796 18.4783 17.6241 18.4012 17.4689C18.3231 17.3126 17.7012 15.7814 17.4408 15.171C17.1908 14.5626 16.9335 14.6397 16.7408 14.6397C16.1408 14.5876 15.7022 14.596 15.3158 14.9981C13.6345 16.846 14.0585 18.7522 15.497 20.7793C18.3241 24.4793 19.8304 25.1606 22.5845 26.1064C23.3283 26.3428 24.0064 26.3095 24.5429 26.2324C25.1408 26.1376 26.3835 25.4814 26.6429 24.747C26.9085 24.0126 26.9085 23.4033 26.8304 23.2626C26.7533 23.122 26.5491 23.0439 26.2366 22.9033Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(8 8.00024)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsapp-icon.20d6fed07fd43336c413d305d5861c54.svg";
export { ForwardRef as ReactComponent };